import { MaskedTextField } from "../../MaskedTextField";

export const WorkScheduleDayTextField = ({
  mask = "99:99",
  driverEdit,
  name,
  label,
  helperText,
  viewOnly = false,
  disabledControls = {},
  errors = {},
  onChange = () => {},
}) => (
  <MaskedTextField
    mask={mask}
    name={name}
    value={driverEdit[name]}
    label={label}
    helperText={helperText}
    error={errors[name]}
    disabled={viewOnly || !!disabledControls[name]}
    onChange={onChange}
  />
);
